import { atom } from "recoil";

export const submittedData = atom({
  key: "submittedData",
  default: undefined,
});
